module.exports = __webpack_public_path__ + "media/images/design/images/icons/instagram-White-a7fb1f92dadb912f4b92045840c2d79f.png";